package com.macrofocus.eflux.network.schema

import org.locationtech.jts.geom.Polygon
import org.molap.dataframe.ListDataFrameBuilder

data class Schema(val schemaId: Int, val logicalGeometry: Polygon) {
    companion object {
        val dataFrameBuilder: ListDataFrameBuilder<Schema, String>.() -> Unit = {
            "schemaId" to { schemaId }
            "logicalGeometry" to { logicalGeometry }
        }
    }
}
